<template>
    <div class="contributions columns is-multiline  mx-2">
        <settings-sidebar :active-menu-item="'contributions'"
                          class="column is-3 py-2 mr-md-3 mb-3 mb-md-auto"></settings-sidebar>
        <div class="column card p-3 px-2 px-md-6 mb-3">
            <h1 class="h2 t-orange mb-3">Your Contributions</h1>
            <ul class="contributors rows" v-if="contributions">
                <li class="contributor row px-3 py-12px t-navy w-100" v-for="contribution in contributions.data">
                    <div class="column p-0 contributor__name py-12px">{{contribution.hazard.name}}</div>
                    <div class="column p-0 contributor__total font-weight-light">
                        {{formattedDate(contribution.created_at)}}
                    </div>
                    <div class="column p-0 contributor__btn text-sm-right">
                        <a :href="contribution.hazard.url" class="btn btn-ghost bg-white">View</a>
                    </div>
                </li>
            </ul>

            <template v-if="contributions.last_page > 1" class="mt-3">
                <paginate
                    :page-count="contributions.last_page"
                    :prev-text="'&nbsp;'"
                    :next-text="'&nbsp;'"
                    :prev-link-class="'pagination-previous'"
                    :next-link-class="'pagination-next'"
                    :container-class="'pagination-list'"
                    :page-class="'pagination-item'"
                    :page-link-class="'pagination-link'"
                    :click-handler="paginate">
                </paginate>
            </template>
        </div>
    </div>
</template>

<script>
    import SettingsSidebar from '../../shared/SettingsSidebar';
    import {mapActions, mapState} from "vuex";

    export default {
        name: 'CatUxoPageContributions',
        components: {
            SettingsSidebar
        },
        props: {
            user: {
                type: Object,
                required: true
            }
        },
        data: function () {
            return {}
        },
        methods: {
            ...mapActions('contribution', [
                'fetchContributorContributions',
            ]),
            formattedDate(date) {
                return moment(date, 'YYYY-MM-DD HH:mm:ss').format('Do MMMM YYYY');
            },
            paginate: function (page) {
                this.fetchContributorContributions({contributorId: this.user.id, page: page});
            },
        },
        computed: {
            ...mapState('contribution', [
                'fetchingContributions',
                'contributions',
            ]),
        },
        created() {
            this.fetchContributorContributions({contributorId: this.user.id, page: 1});
        },
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>
    .row {
        &:nth-child(even) {
            background: $c-white;
        }

        &:nth-child(odd) {
            background: $c-light-grey;
            color: $c-navy-blue;
        }
    }

    @include media-breakpoint-down(xs) {
        .row {
            display: block;

            .btn {
                margin-top: rem(12px);
            }
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/pages/settings/Contributions.vue